export default "__VITE_ASSET__b3a350d1__"